import React, { useState, useEffect, useRef } from "react";
import { Form, Button, Collapse } from "react-bootstrap";
import { FaAngleDown } from "react-icons/fa";

const CategorySelectionComponent = ({
  options,
  handleCheckChange,
  categoryItems,
}) => {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  // Function to handle click outside the component
  const handleClickOutside = (event) => {
    if (ref.current && !ref.current.contains(event.target)) {
      setOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  return (
    <Form ref={ref}>
      <Button
        onClick={() => setOpen(!open)}
        // disabled={focusItems.length ==0}
        aria-controls="example-collapse-text"
        aria-expanded={open}
        variant="default"
        style={{
          backgroundColor: "white",
          width: "100%",
          height: "50px",
          padding: "11.5px 10px",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            fontSize: "0.95rem",
            fontWeight: "360",
          }}
        >
          {categoryItems.length !== 0 ? (
            <>
              {categoryItems.length === 1 ? (
                <span style={{ textWrap: "nowrap", textOverflow: "ellipsis", overflow: "hidden" }}>
                  {categoryItems[0]}
                </span>
              ) : (
                <span> ({categoryItems.length}) selected </span>
              )}
            </>
          ) : (
            <span>
              Select Category Type<span></span>
            </span>
          )}
          <FaAngleDown
            style={{
              transform: open ? "rotate(180deg)" : "rotate(0)", // Rotate the icon based on the dropdown state
              transition: "transform 0.3s ease-in-out", // Add transition for smooth animation
            }}
          />
        </div>
      </Button>
      <Collapse
        style={{
          position: "absolute",
          backgroundColor: "white",
          width: "16.3%",
          zIndex: 1,
        }}
        in={open}
      >
        <div id="example-collapse-text">
          <Form.Group controlId="exampleForm.SelectCustom">
            {options.map((option) => (
              <Form.Check
                style={{ fontSize: "0.80rem", fontWeight: "600" }}
                key={option}
                type="checkbox"
                label={option}
                className={`mb-2 customData`}
                checked={categoryItems.includes(option)}
                onChange={(event) => handleCheckChange(option)}
              />
            ))}
          </Form.Group>
        </div>
      </Collapse>
    </Form>
  );
};

export default CategorySelectionComponent;
